module.exports = __webpack_public_path__ + "static/media/KNC.c11b8d81.svg";